module.exports = __webpack_public_path__ + "static/media/non-risky-comorbidity.66a0ef1b.svg";